import { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ButtonPrimary, RadioButton } from '@comeon/ui';

import { toggleLocaleSelector } from '~/components/brand/ducks';
import { selectLocales } from '~/components/brand/ducks/selectors';
import SidebarHeader from '~/components/header/sidebar-header';
import ButtonWrapper from '~/components/misc/button-wrapper';
import IconButtonClose from '~/components/misc/icon-button-close';
import Loading from '~/components/misc/loading';
import useTranslations from '~/components/translation/use-translations';
import { getZindexByType } from '~/utils/style-utils';

import { selectorTextKeys } from './constants';
import { changeLanguage, selectedLocale } from './utils';

const LocaleSelector = () => {
	const dispatch = useDispatch();
	const currentLocale = useSelector(selectedLocale);
	const locales = useSelector(selectLocales);
	const [selectedItem, setSelectedItem] = useState(currentLocale);

	const { translations: t, isLoadingTranslations } = useTranslations(selectorTextKeys);
	const loadedClass = 'slide-in-up';

	const changeSelected = useCallback(item => setSelectedItem(item), []);

	if (isLoadingTranslations) {
		return <Loading />;
	}

	return (
		<>
			<SidebarHeader
				className="country-select-header"
				zIndex={getZindexByType('modal-view') + 2}
				Icon={
					<IconButtonClose
						className="at-icon-close page-head__close"
						dataAt="close-country-global-overlay"
						onClick={() => {
							dispatch(toggleLocaleSelector());
						}}
					/>
				}
			>
				<h1 className="page-head__title" data-at="title-country-global-overlay">
					{t.ALTER_YOUR_LANGUAGE_SETTINGS}
				</h1>
				<div className="page-head__right-side" />
			</SidebarHeader>
			<div className={`list-options modal-view u-standard-padding ${loadedClass}`}>
				<ul className="custom-checkbox-list u-pb-md">
					{locales.map(
						currentItem =>
							currentItem.locale !== 'sv_GU' &&
							currentItem.locale !== 'fi_GU' && (
								<li key={`${currentItem.locale}`}>
									<RadioButton
										id={`${currentItem.locale}`}
										isChecked={selectedItem === currentItem}
										onChange={() => changeSelected(currentItem)}
										title={`${currentItem.description}`}
									/>
								</li>
							)
					)}
				</ul>

				<ButtonWrapper>
					<ButtonPrimary
						className="btn"
						disabled={selectedItem === currentLocale}
						data-message="{{#i18n}}MOBILE_METHOD_CONTINUE{{/i18n}}"
						onClick={() => changeLanguage(selectedItem)}
					>
						{t.MOBILE_METHOD_CONTINUE}
					</ButtonPrimary>
				</ButtonWrapper>
			</div>
		</>
	);
};

export default LocaleSelector;
